<template>
    <simple-layout horizontal>
        <template v-if="loading">
            <basic-card>
                <loader indefinite/>
            </basic-card>
        </template>
        <template v-if="!loading">
            <simple-layout v-for="(column, colIdx) in dashboard.content">
                <template v-for="(widget, widgetIdx) in column">
                    <component :is="`${widget.widgetType}Widget`"
                               v-bind="{ ... widget.options, displayName: widget.displayName}"/>
                </template>
            </simple-layout>
        </template>
    </simple-layout>
</template>

<script>
import SimpleLayout from "../components/layout/SimpleLayout";
import BasicCard from "../components/layout/BasicCard";
import { mapGetters } from "vuex";
import StaticTextWidget from "../components/dashboards/Widgets/StaticTextWidget";
import AccountBalancesOverviewWidget from "../components/dashboards/Widgets/AccountBalancesOverviewWidget";
import AccountBalancesForAccountWidget from "../components/dashboards/Widgets/AccountBalancesForAccountWidget";
import PaymentBatchesWidget from "../components/dashboards/Widgets/PaymentBatchesWidget";
import GeoAccountBalancesWidget from "../components/dashboards/Widgets/GeoAccountBalancesWidget";
import SimpleExchangeRateWidget from "../components/dashboards/Widgets/SimpleExchangeRateWidget";
import SimpleProcessHistoryWidget from "../components/dashboards/Widgets/SimpleProcessHistoryWidget";
import Loader from "../components/Loader";
import SingleCashflowCellWidget from "../components/dashboards/Widgets/SingleCashflowCellWidget";
import SimpleRunActionWidget from "../components/dashboards/Widgets/SimpleRunActionWidget";
import SimpleResourceListWidget from "../components/dashboards/Widgets/SimpleResourceListWidget";

import OperationDefinitionsListWidget from '../components/dashboards/Widgets/OperationDefinitionsListWidget';
import OperationListWidget from '../components/dashboards/Widgets/OperationListWidget';

export default {
    name: "SingleDashboardView",
    components: {
        SingleCashflowCellWidget,
        Loader,
        BasicCard,
        SimpleLayout,
        StaticTextWidget,
        AccountBalancesOverviewWidget,
        AccountBalancesForAccountWidget,
        PaymentBatchesWidget,
        SimpleExchangeRateWidget,
        SimpleProcessHistoryWidget,
        GeoAccountBalancesWidget,
        OperationDefinitionsListWidget,
        OperationListWidget,
        SimpleRunActionWidget,
        SimpleResourceListWidget
    },
    data() {
        return {
            dashboard: {},
            loading: true
        }
    },
    mounted() {
        this.dashboard = this.$_.cloneDeep(this.actualDashboard);
        this.dashboard.content = JSON.parse(this.dashboard.content);
        Promise.all([this.$store.dispatch("banking/refreshAllBalances"),
            this.$store.dispatch(`accountQueries/refreshAccountQueries`)]).then(() => {
            this.loading = false;
        })

    },
    computed: {
        ...mapGetters({"dashboards": "dashboards/dashboards"}),
        actualDashboard() {
            const dashboardId = this.$route.params.dashboardId;
            if (dashboardId == 'home') {
                return this.dashboards.find(dashboard => dashboard.home);
            }
            return this.dashboards.find(dashboard => dashboard.id == dashboardId)
        }
    }
}
</script>

<style scoped>

</style>
